module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumbs', {
    attrs: {
      "crumbs": []
    }
  }, [_c('div', {
    staticClass: "folders-breadcrumbs"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.goToFolder(_vm.path[0].id)
      }
    }
  }, [_vm._v("Reports")]), _vm._v(" "), _vm._l((_vm.path), function(breadcrumb, idx) {
    return [(idx > 0) ? _c('a', {
      staticClass: "folder-path-link",
      on: {
        "click": function($event) {
          return _vm.goToFolder(breadcrumb.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: {
        'fa-folder-o': idx !== _vm.path.length - 1,
        'fa-folder-open-o': idx === _vm.path.length - 1
      }
    }), _vm._v(_vm._s(breadcrumb.name))]) : _vm._e(), (idx !== _vm.path.length - 1) ? _c('i', {
      staticClass: "fa fa-angle-right"
    }) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [(_vm.user.access > 3) ? _c('div', [_c('router-link', {
    staticClass: "btn green",
    attrs: {
      "to": {
        name: 'Reports Add'
      },
      "tag": "button"
    }
  }, [_vm._v("Add New Report")]), _vm._v(" "), _c('a', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        return _vm.showModal('createFolder')
      }
    }
  }, [_vm._v("Add New Folder")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-body",
    class: {
      loading: _vm.loading.list
    }
  }, [(_vm.loading.list) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vgt-responsive"
  }, [_c('table', {
    staticClass: "vgt-table bordered"
  }, [_c('thead', [_c('tr', [_vm._l((_vm.columns), function(col) {
    return _c('th', {
      class: {
        'cell-actions': col.field === 'action',
        'sortable sorting': col.field !== 'action',
        'sorting-asc': _vm.sortBy === col.field && _vm.sortDir === 'asc',
        'sorting-desc': _vm.sortBy === col.field && _vm.sortDir === 'desc',
      }
    }, [_c('span', [_vm._v(_vm._s(col.label))]), _vm._v(" "), (col.field !== 'action') ? _c('button', {
      on: {
        "click": function($event) {
          return _vm.sort(col.field)
        }
      }
    }, [_c('span', {
      staticClass: "sr-only"
    }, [_vm._v("\n                            Sort table by Status in descending order\n                          ")])]) : _vm._e()])
  }), _vm._v(" "), _vm._m(1)], 2), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "filter-th"
  }, [_c('div', [_c('input', {
    staticClass: "vgt-input",
    attrs: {
      "type": "text",
      "placeholder": "Filter Name"
    },
    on: {
      "change": function($event) {
        return _vm.filter('name', $event)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "filter-th"
  }, [_c('div', [_c('input', {
    staticClass: "vgt-input",
    attrs: {
      "type": "text",
      "placeholder": "Filter Description"
    },
    on: {
      "change": function($event) {
        return _vm.filter('description', $event)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "filter-th"
  }), _vm._v(" "), _c('th', {
    staticClass: "filter-th"
  }, [_c('div', [_c('input', {
    staticClass: "vgt-input",
    attrs: {
      "type": "text",
      "placeholder": "Filter Created By"
    },
    on: {
      "change": function($event) {
        return _vm.filter('user', $event)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "filter-th"
  }), _vm._v(" "), _c('th', {
    staticClass: "filter-th"
  }), _vm._v(" "), _c('th', {
    staticClass: "filter-th"
  }), _vm._v(" "), _c('th', {
    staticClass: "filter-th"
  })])]), _vm._v(" "), _c('tbody', [(_vm.parentFolder) ? _c('tr', {
    staticClass: "folder",
    class: 'folder' + _vm.parentFolder.id,
    attrs: {
      "draggable": "true"
    },
    on: {
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "dragenter": _vm.dragEnter,
      "dragleave": _vm.dragLeave,
      "dragover": function($event) {
        return _vm.dragOver(_vm.parentFolder.id, 'folder', $event)
      }
    }
  }, [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToFolder(_vm.parentFolder.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-level-up dark"
  }), _vm._v(" ... ")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.folders), function(row) {
    return _c('tr', {
      staticClass: "folder",
      class: 'folder' + row.id,
      attrs: {
        "draggable": "true"
      },
      on: {
        "dragstart": function($event) {
          $event.stopPropagation();
          return _vm.dragStart(row.id, 'folder', $event)
        },
        "dragover": function($event) {
          return _vm.dragOver(row.id, 'folder', $event)
        },
        "dragenter": _vm.dragEnter,
        "dragleave": _vm.dragLeave,
        "dragend": function($event) {
          return _vm.dragEnd(row.id, 'folder', $event)
        },
        "drop": function($event) {
          return _vm.dragFinish(row.id, $event)
        }
      }
    }, [_c('td', {
      staticClass: "folder",
      attrs: {
        "colspan": "7"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.goToFolder(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-folder-o dark"
    }), _vm._v("  " + _vm._s(row.name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "last-dropdown"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_vm._m(2, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu",
      attrs: {
        "role": "menu"
      }
    }, [_c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showEditFolderModal(row.id, row.name)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    }), _vm._v(" Edit")])]), _vm._v(" "), (_vm.user.access > 3) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showModal('moveToFolder', {
            type: 'folder',
            id: row.id
          })
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrows"
    }), _vm._v(" Move ")])]) : _vm._e(), _vm._v(" "), (_vm.user.access > 3) ? _c('li', {
      staticClass: "divider"
    }) : _vm._e(), _vm._v(" "), (_vm.user.access > 3) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showModal('deleteFolder', row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete\n                                ")])]) : _vm._e()])])])]), _vm._v(" "), _c('td')])
  })], 2), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row) {
    return (_vm.reports.length) ? _c('tr', {
      staticClass: "item",
      attrs: {
        "draggable": "true"
      },
      on: {
        "dragstart": function($event) {
          $event.stopPropagation();
          return _vm.dragStart(row.id, 'item', $event)
        },
        "dragover": function($event) {
          return _vm.dragOver(row.id, 'report', $event)
        },
        "dragenter": _vm.dragEnter,
        "dragleave": _vm.dragLeave,
        "dragend": function($event) {
          return _vm.dragEnd(row.id, 'report', $event)
        },
        "drop": function($event) {
          return _vm.dragFinish(row.id, $event)
        }
      }
    }, [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Reports Preview',
          params: {
            reportid: row.id
          }
        },
        "tag": "a"
      }
    }, [_vm._v(_vm._s(row.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.description))]), _vm._v(" "), _c('td', {
      staticClass: "vgt-text-nowrap"
    }, [_vm._v(_vm._s([2, 4].includes(row.mode) ? 'Multiple Organizations' : 'Single Organization'))]), _vm._v(" "), _c('td', {
      staticClass: "vgt-text-nowrap"
    }, [_vm._v(_vm._s(row.user))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(row.created_date.date)))]), _vm._v(" "), _c('td', [(row.modified_date !== null) ? [_vm._v(_vm._s(_vm._f("formatDate")(row.modified_date.date)))] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s((row.status == 1) ? 'Published' : 'Unpublished'))]), _vm._v(" "), _c('td', {
      staticClass: "cell-action"
    }, [_c('div', {
      staticClass: "last-dropdown"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_vm._m(3, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu",
      attrs: {
        "role": "menu"
      }
    }, [(_vm.user.access > 3 && !row.parent_id) ? _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Reports Edit',
          params: {
            reportid: row.id
          }
        },
        "tag": "a"
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    }), _vm._v(" Edit\n                                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.access > 3) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changeStatusAction(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" Publish / Draft ")])]) : _vm._e(), _vm._v(" "), (_vm.user.access > 3) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showModal('duplicate', row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-files-o"
    }), _vm._v(" Duplicate ")])]) : _vm._e(), _vm._v(" "), (_vm.user.access > 3) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showModal('moveToFolder', {
            type: 'report',
            id: row.id
          })
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrows"
    }), _vm._v(" Move ")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.exportReport(row.id, row.count)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-o"
    }), _vm._v(" Export\n                                ")])]), _vm._v(" "), (_vm.user.access > 3 && !row.parent_id) ? _c('li', {
      staticClass: "divider"
    }) : _vm._e(), _vm._v(" "), (_vm.user.access > 3 && !row.parent_id) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showDeleteReportModal(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete\n                                ")])]) : _vm._e()])])])]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "mt-checkbox mt-checkbox-outline"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "disabled": _vm.topReportsIds.length >= 5 && !_vm.topReportsIds.includes(row.id)
      },
      domProps: {
        "value": row.id,
        "checked": _vm.topReportsIds.includes(row.id)
      },
      on: {
        "change": function($event) {
          $event.preventDefault();
          return _vm.selectTopReport(row.id)
        }
      }
    }), _vm._v(" "), _c('span')])])]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "vgt-wrap__footer vgt-clearfix"
  }, [(!_vm.reports.length) ? [_c('h4', [_vm._v("Sorry, no results were found.")])] : _vm._e(), _vm._v(" "), (_vm.reports.length) ? [_c('div', {
    staticClass: "footer__row-count vgt-pull-left"
  }, [_c('span', {
    staticClass: "footer__row-count__label"
  }, [_vm._v("Rows per page")]), _vm._v(" "), _c('select', {
    staticClass: "footer__row-count__select",
    attrs: {
      "autocomplete": "off",
      "name": "perPageSelect"
    },
    on: {
      "change": _vm.changePerPage
    }
  }, _vm._l((_vm.perPageSelectOptions), function(option) {
    return _c('option', {
      domProps: {
        "selected": _vm.perPage === option,
        "value": option
      }
    }, [_vm._v("\n                          " + _vm._s(option === 0 ? 'All' : option) + "\n                        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "footer__navigation vgt-pull-right"
  }, [_c('a', {
    staticClass: "footer__navigation__page-btn",
    class: {
      'disabled': _vm.currentPage == 0
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }, [_c('span', {
    staticClass: "chevron left"
  }), _c('span', [_vm._v("Prev")])]), _vm._v(" "), _c('div', {
    staticClass: "footer__navigation__info"
  }, [_vm._v(_vm._s((_vm.reportsCount ? _vm.currentPage * _vm.perPage + 1 : 0)) + " - " + _vm._s(_vm.visibleRowsCount) + " of " + _vm._s(_vm.reportsCount))]), _vm._v(" "), _c('a', {
    staticClass: "footer__navigation__page-btn",
    class: {
      'disabled': (this.perPage * this.currentPage + this.perPage + 1 > this.reportsCount) || (this.reportsCount <= _vm.perPage) || _vm.perPage === 0
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_c('span', [_vm._v("Next")]), _vm._v(" "), _c('span', {
    staticClass: "chevron right"
  })])])] : _vm._e()], 2)], 1), _vm._v(" "), _c('router-link', {
    staticClass: "view-top-reports btn default pull-right",
    attrs: {
      "to": {
        name: 'Top 5 Reports List'
      }
    }
  }, [_vm._v("View Top 5 Reports")]), _vm._v(" "), _c('button', {
    staticClass: "save-top-reports btn green pull-right",
    on: {
      "click": _vm.saveTopReports
    }
  }, [_vm._v("Save Top 5 Reports")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)])])])]), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "id": "delete-report-modal",
      "title": "DELETE REPORT",
      "question": "Are you sure you would like to delete this Report?"
    },
    on: {
      "confirmed": function($event) {
        return _vm.deleteReportAction(_vm.currentModal)
      }
    }
  }), _vm._v(" "), _c('duplicate-report-modal', {
    attrs: {
      "report-id": _vm.currentModal
    },
    on: {
      "save": function($event) {
        return _vm.getReportsAction({
          type: 'report'
        })
      }
    },
    model: {
      value: (_vm.showModalMap.duplicate),
      callback: function($$v) {
        _vm.$set(_vm.showModalMap, "duplicate", $$v)
      },
      expression: "showModalMap.duplicate"
    }
  }), _vm._v(" "), _c('create-folder-modal', {
    model: {
      value: (_vm.showModalMap.createFolder),
      callback: function($$v) {
        _vm.$set(_vm.showModalMap, "createFolder", $$v)
      },
      expression: "showModalMap.createFolder"
    }
  }), _vm._v(" "), _c('delete-folder-modal', {
    attrs: {
      "folder-id": _vm.currentModal
    },
    model: {
      value: (_vm.showModalMap.deleteFolder),
      callback: function($$v) {
        _vm.$set(_vm.showModalMap, "deleteFolder", $$v)
      },
      expression: "showModalMap.deleteFolder"
    }
  }), _vm._v(" "), _c('edit-folder-modal', {
    attrs: {
      "folder-id": _vm.currentModal,
      "folder-name": _vm.editFolderName
    },
    model: {
      value: (_vm.showModalMap.editFolder),
      callback: function($$v) {
        _vm.$set(_vm.showModalMap, "editFolder", $$v)
      },
      expression: "showModalMap.editFolder"
    }
  }), _vm._v(" "), _c('move-to-folder-modal', {
    attrs: {
      "element-id": _vm.currentModal && _vm.currentModal.id,
      "element-type": _vm.currentModal && _vm.currentModal.type
    },
    model: {
      value: (_vm.showModalMap.moveToFolder),
      callback: function($$v) {
        _vm.$set(_vm.showModalMap, "moveToFolder", $$v)
      },
      expression: "showModalMap.moveToFolder"
    }
  }), _vm._v(" "), (_vm.showExportModal) ? _c('export-modal', {
    attrs: {
      "report-id": _vm.exportReportId,
      "result-total-rows": _vm.exportTotalRows
    },
    on: {
      "display": function($event) {
        _vm.showExportModal = $event
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('i', {
    staticClass: "icon-globe theme-font hide"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v("Reports")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Top 5"), _c('br'), _vm._v("Reports")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-xs green dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-expanded": "false"
    }
  }, [_vm._v(" Actions\n                              "), _c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-xs green dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-expanded": "false"
    }
  }, [_vm._v(" Actions\n                              "), _c('i', {
    staticClass: "fa fa-angle-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c9a4b90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reports/ReportsList.vue
// module id = 1720
// module chunks = 1